import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import QuantityInput from 'apps/quantityControls/components/QuantityInput';

import { msg } from 'api';
import { requestLogin } from 'utils/loginAndRegistration/login';

export default class QuantityInputWithAddToBasket extends PureComponent {
  static propTypes = {
    analyticsContextData: PropTypes.object,
    isLoggedIn: PropTypes.bool,
    isUpdating: PropTypes.bool,
    loggedOutBasket: PropTypes.bool,
    maxQuantity: PropTypes.number,
    minQuantity: PropTypes.number,
    onQuantitySubmit: PropTypes.func.isRequired,
    productWarning: PropTypes.bool,
    quantity: PropTypes.number,
    router: PropTypes.object.isRequired,
    sku: PropTypes.string.isRequired,
  };

  static defaultProps = {
    minQuantity: 0,
    maxQuantity: 99,
  }

  handleLoggedOut = () => {
    const { router } = this.props;
    requestLogin(router);
  }

  addToTrolley = (event) => {
    event.preventDefault();

    if (!this.props.loggedOutBasket && !this.props.isLoggedIn) {
      this.handleLoggedOut();
      return;
    }

    const { sku, analyticsContextData } = this.props;

    this.props.onQuantitySubmit(sku, 1, analyticsContextData);
  }

  renderFullControls() {
    return (
      <QuantityInput
        {...this.props}
        onQuantitySubmit={(...props) => this.props.onQuantitySubmit(this.props.sku, ...props)}
      />
    );
  }

  renderAddToTrolleyButton() {
    const { isUpdating, productWarning } = this.props;

    return (
      <div className="button-wrapper">
        <div className="button-section">
          <button
            type="submit"
            className="fop-btn-add fop-btn-add-single fop-btn-add-to-trolley"
            disabled={productWarning || isUpdating}
            name="addproduct"
            onClick={this.addToTrolley}
            aria-label="Add to trolley"
          >
            <span className="add-to-trolley">{msg.fop.addButton.addToTrolleyLabel}</span>
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { quantity } = this.props;

    const shouldRenderFullControls = quantity > 0;

    return (
      shouldRenderFullControls
        ? this.renderFullControls()
        : this.renderAddToTrolleyButton()
    );
  }
}
